/* Event delegation keeps controls working after Shopify theme-editor section renders. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  let headerObserver;
  let stickySection;

  // Desktop pins the navigation row; mobile pins its single logo/cart/menu row.
  // ResizeObserver accounts for mobile layout, merchant logos, fonts and announcement copy.
  function initializeStickyNavigation() {
    headerObserver?.disconnect();
    stickySection?.classList.remove('sw-sticky-navigation-ready');
    const header = document.querySelector('.sw-header-two-row');
    const navigation = header?.querySelector('.sw-header-navigation');
    stickySection = header?.closest('.shopify-section-group-header-group');
    if (!navigation || !stickySection) return;
    const section = stickySection;
    const measure = () => {
      const stickyRow = getComputedStyle(navigation).display === 'none' ? header : navigation;
      const height = stickyRow.getBoundingClientRect().top - section.getBoundingClientRect().top;
      section.style.setProperty('--sw-header-scroll-height', `${Math.max(0, height)}px`);
      section.classList.add('sw-sticky-navigation-ready');
    };
    measure();
    headerObserver = new ResizeObserver(measure);
    headerObserver.observe(header);
    const announcement = section.querySelector('.sw-announcement');
    if (announcement) headerObserver.observe(announcement);
  }
  initializeStickyNavigation();
  document.addEventListener('shopify:section:load', initializeStickyNavigation);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target === stickySection) {
      headerObserver?.disconnect();
      stickySection = null;
    }
  });

  document.addEventListener('click', event => {
    const menu = event.target.closest('.sw-menu-toggle');
    if (menu) {
      const nav = document.getElementById(menu.getAttribute('aria-controls'));
      if (!nav) return;
      const expanded = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', String(!expanded));
      menu.setAttribute('aria-label', expanded ? menu.dataset.openLabel : menu.dataset.closeLabel);
      nav.hidden = expanded;
    }

    const galleryButton = event.target.closest('[data-gallery-src]');
    if (galleryButton) {
      const gallery = galleryButton.closest('.sw-gallery');
      const image = gallery?.querySelector('.sw-gallery-main img');
      if (!image) return;
      image.removeAttribute('srcset');
      image.src = galleryButton.dataset.gallerySrc;
      image.alt = galleryButton.dataset.galleryAlt;
      gallery.querySelectorAll('[data-gallery-src]').forEach(button => {
        button.classList.toggle('is-active', button === galleryButton);
        button.setAttribute('aria-pressed', String(button === galleryButton));
      });
    }

    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const input = quantityButton.closest('.sw-quantity')?.querySelector('input');
      if (!input) return;
      const min = Number(input.min) || 1;
      const step = Number(input.step) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      const quantity = Number.parseInt(input.value, 10) || min;
      input.value = Math.min(max, Math.max(min, quantity + step * Number(quantityButton.dataset.quantityChange)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.sw-menu-toggle[aria-expanded="true"]');
    if (menu) { menu.click(); menu.focus(); }
  });

  document.addEventListener('change', event => {
    if (event.target.matches('[data-auto-submit]')) event.target.form?.requestSubmit();
    if (event.target.id === 'sw-variant') {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', event.target.value);
      window.location.assign(url);
    }
  });

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.getAttribute('id') !== 'sw-product-form' || event.submitter?.name !== 'add') return;
    event.preventDefault();
    const buttons = [...document.querySelectorAll('button[name="add"]')];
    const error = form.querySelector('.sw-form-error');
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    error.textContent = '';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || error.dataset.errorMessage);
      const drawer = document.querySelector('sw-cart-drawer');
      if (typeof drawer?.refresh === 'function') {
        try { await drawer.refresh(); drawer.show(event.submitter); }
        catch (drawerError) { console.warn('Safe World cart drawer:', drawerError.message); window.location.assign(`${root}cart`); }
      } else window.location.assign(`${root}cart`);
    } catch (err) {
      error.textContent = err.message || error.dataset.errorMessage;
    } finally {
      buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    }
  });

  // Selecting an FAQ block reveals its content inside the editor.
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
})();
